module.exports = __webpack_public_path__ + "assets/img/cpc.b15e181a.png";